// src/pages/RecommendedCandidates.js
import React from 'react';
import { Box, Grid, Typography, Container, Card, CardContent, CardActions, Button, Chip } from '@mui/material';
import SidebarCard from '../components/candidates/CandidateSidebar';  // 引入左侧卡片
import SidebarRight from '../components/SidebarRight';

const RecommendedCandidates = () => {
    return (
        <Container maxWidth="lg" sx={{ marginTop: 4 }}>
            <Grid container spacing={2}>
                {/* 左侧卡片 */}
                <Grid item xs={12} sm={3}>
                    <SidebarCard />
                </Grid>

                {/* 右侧的候选人推荐内容 */}
                <Grid item xs={12} md={6}>
                    {/* 候选人搜索建议 */}
                    <Typography variant="h6" gutterBottom>候选人搜索建议</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        <Chip label="前端开发" />
                        <Chip label="后端开发" />
                        <Chip label="产品经理" />
                        <Chip label="UI设计师" />
                        <Chip label="数据分析" />
                        <Chip label="机器学习" />
                        <Chip label="市场营销" />
                    </Box>

                    {/* 热门候选人推荐 */}
                    <Box sx={{ marginTop: '40px' }}>
                        <Typography variant="h6" gutterBottom>热门候选人推荐</Typography>
                        <Typography variant="subtitle1" gutterBottom>根据您的企业需求和招聘记录</Typography>

                        <Card>
                            <CardContent>
                                <Typography variant="h6">王小明</Typography>
                                <Typography variant="body2">前端开发工程师</Typography>
                                <Typography variant="body2">技能: JavaScript, React, HTML/CSS</Typography>
                                <Typography variant="body2">期望地点: 北京, 中国 (现场办公)</Typography>
                                <Typography variant="body2">期望薪资: ¥20K/月 - ¥30K/月</Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small">查看详情</Button>
                            </CardActions>
                        </Card>

                        <Card sx={{ marginTop: '20px' }}>
                            <CardContent>
                                <Typography variant="h6">李四</Typography>
                                <Typography variant="body2">后端开发工程师</Typography>
                                <Typography variant="body2">技能: Node.js, MongoDB, Docker</Typography>
                                <Typography variant="body2">期望地点: 远程办公</Typography>
                                <Typography variant="body2">期望薪资: ¥15K/月 - ¥25K/月</Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small">查看详情</Button>
                            </CardActions>
                        </Card>
                    </Box>

                    {/* 更多候选人推荐 */}
                    <Button sx={{ marginTop: 2 }}>显示全部</Button>
                </Grid>

                {/* 右侧栏 */}
                <Grid item xs={12} md={3}>
                    <SidebarRight />
                </Grid>
            </Grid>
        </Container>
    );
};

export default RecommendedCandidates;